import React from "react"
import { Hidden, Tooltip } from "@material-ui/core"
import { Menu } from "@material-ui/icons"
import PropTypes from "prop-types"
import { StyledButton } from "src/components/Buttons/TgButton"

const SideNavTrigger = ({ onOpen }) => (
  <Hidden mdUp>
    <Tooltip title="Abrir menú lateral">
      <StyledButton onClick={onOpen}>
        <Menu />
      </StyledButton>
    </Tooltip>
  </Hidden>
)

SideNavTrigger.propTypes = {
  onOpen: PropTypes.func.isRequired,
}

export default SideNavTrigger
